import SystemPattern from './S.Pattern';

export default SystemPattern
export { SystemPattern as Base }
